import globalAxios from "../../../util/Api";
import {
  GET_ARCHIVES,
  START_LOADING,
  STOP_LOADING,
} from "./types";
import { LogoutAction } from "../../../actions";
import moment from 'moment'
import { API_URL } from "../../../constants";

export const GetArchives = (yearField, monthField, type) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/reports/archive?year=${yearField}&month=${monthField}&type=${type}`)
      .then(res => {
        dispatch({ type: GET_ARCHIVES, payload: res.data.archives })
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const GetArchivesFile = (Id, type, date) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/reports/archive_file?id=${Id}`)
      .then(res => {
        const theLink = document.createElement('a');
        theLink.href = API_URL + res.data.data_base64;
        if (type === "Akquiseliste")
          theLink.download = `Akquiseliste_${moment(date).utc().format("DD.MM.YYYY")}.xlsx`;
        else if (type === "6 Monatsplan")
          theLink.download = `6-Monatsplan_${moment(date).utc().format("DD.MM.YYYY")}.pdf`;
        else
          theLink.download = `Beraterplan_${moment(date).utc().format("DD.MM.YYYY")}.pdf`;
        document.body.appendChild(theLink);
        theLink.click();
        document.body.removeChild(theLink);
        dispatch({ type: STOP_LOADING })
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}

export const StopLoading = () => {
  return (dispatch) => {
    dispatch({ type: STOP_LOADING })
  }
}
